import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SkuActionsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';

import { PackageTypes } from '@shared/models';
import type { TResponse, TSkuAction, TPackageType } from '@shared/models';

@Component({
    'selector': 'app-skuAction',
    'templateUrl': './skuAction.page.html',
    'styleUrls': ['./skuAction.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class SkuActionPage extends ViewBasePage implements OnInit {
    public vm: TSkuAction;
    private uid = '';

    public submitted = false;
    public payAsYouGoPackages: any;
    public selectGroupValue = '';

    constructor(private activatedRoute: ActivatedRoute, private skuActionsService: SkuActionsService,
        private location: Location, injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        // Provide default values during the change detection cycle.
        this.vm = this.skuActionsService.getNullable();

        this.uid = this.activatedRoute.snapshot.paramMap.get('uid');
        if (this.uid) {
            await this.uxHelperService.showSpinner();

            this.vm = await this.skuActionsService.getByUid(this.uid);
            this.vm.increaseExpirationDays = this.vm.increaseExpirationDays || 0;
            this.vm.increaseExpirationMonths = this.vm.increaseExpirationMonths || 0;
            this.vm.increaseExpirationYears = this.vm.increaseExpirationYears || 0;
            this.vm.increasePremiumSupportMonths = this.vm.increasePremiumSupportMonths || 0;
            this.vm.increasePremiumSupportYears = this.vm.increasePremiumSupportYears || 0;
            this.vm.type = this.vm.type || 'Pay As You Go';
            this.vm.increaseWebHostingMonths = this.vm.increaseWebHostingMonths || 0;
            this.vm.increaseWebHostingYears = this.vm.increaseWebHostingYears || 0;
            this.vm.updatePackageDetails = this.vm.updatePackageDetails || false;
            this.vm.updateActivationInfo = this.vm.updateActivationInfo || false;
            this.vm.updateCredits = this.vm.updateCredits || false;
            this.vm.sendCompleteOrderEmail = this.vm.sendCompleteOrderEmail || false;
            await this.uxHelperService.hideSpinner();
        }
    }

    public async onTypeClick() {
        // const types = ['Activation', 'Pay As You Go', 'Monthly', 'Yearly', 'Ambassador', 'Optional Service'];
        // const types: TPackageType[] = TPackageTypeArray; // ['a', 'b'];
        const response = await this.uxHelperService.showRadioAlert('Select Package Type', [...PackageTypes], this.vm.type);
        if (response.okay) {
            this.vm.type = response.selectedItems[0] as TPackageType;
        }
    }

    public sendEmailText(sendEmailToSupport: boolean): string {
        const messages = ['Send Complete Order Email', 'Do NOT send email'];
        const msg = (sendEmailToSupport) ? messages[0] : messages[1];
        return msg;
    }

    public updatePackageDetailsText(update: boolean): string {
        const messages = ['Update Package Name and Features', 'Do NOT Update Package Name and Features'];
        const msg = (update) ? messages[0] : messages[1];
        return msg;
    }

    public updateCreditsText(update: boolean): string {
        const messages = ['Update Credits', 'Do NOT Update Credits'];
        const msg = (update) ? messages[0] : messages[1];
        return msg;
    }

    public updateActivationInfo(update: boolean): string {
        const messages = ['Update Activation Info', 'Do NOT Update Activation Info'];
        const msg = (update) ? messages[0] : messages[1];
        return msg;
    }

    // public updateHostingText(hosting: boolean): string {
    //     const messages = [ 'Update hosting', 'Do NOT update hosting' ];
    //     const msg = (hosting) ? messages[0] : messages[1];
    //     return msg;
    // }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');
            await this.skuActionsService.update(this.vm);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
            this.location.back();
        }
    }
}
